import React from 'react';
import GroupButtonContainer from '../../Componant/Buttons/GroupBtn';

const GroupButton = () => {
  return (
    <div className='page-body'>
      <GroupButtonContainer />
    </div>
  );
};

export default GroupButton;
